export const EVENT_CHANGE_SETUP_PRESET = 'change-setup-preset';
export const EVENT_KEYBOARD = 'keyboard';
export const EVENT_LOOSE_FOCUS = 'loose-focus';
export const EVENT_STEREO_WINDOW_READY = 'stereo-ready';
export const EVENT_STEREO_WINDOW_TRANSFER = 'transfer-settings';
